<script setup lang="ts">
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide'
import type { SortDirection } from '@/composables/tableSort'
import { SphIcon } from '@/components/base/icon'
import { computed } from 'vue'

defineOptions({
    compatConfig: { MODE: 3 },
})

const props = defineProps<{
    label: string
    sortKey: string
    activeKey: string | null
    direction: SortDirection
}>()

const emit = defineEmits<{ sort: [key: string] }>()

const isActive = computed(() => props.activeKey === props.sortKey)

const icon = computed(() => {
    if (!isActive.value) return ChevronsUpDown
    return props.direction === 'asc' ? ChevronUp : ChevronDown
})
</script>

<template>
    <th
        class="kgr-table__cell kgr-table__cell--headline"
        :aria-sort="isActive ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'"
    >
        <button
            type="button"
            class="flex w-full items-center justify-between gap-2 cursor-pointer bg-transparent border-0 p-0 text-inherit font-inherit"
            @click="emit('sort', sortKey)"
        >
            {{ label }}
            <SphIcon
                :icon="icon"
                size="xs"
                :class="{ 'opacity-40': !isActive }"
            />
        </button>
    </th>
</template>
